/** Translation keys under DEV_CLIENTS.SCOPES.* */
export const OAUTH_SCOPE_I18N_KEYS: Record<string, string> = {
  'products:read': 'DEV_CLIENTS.SCOPES.PRODUCTS_READ',
  'products:write': 'DEV_CLIENTS.SCOPES.PRODUCTS_WRITE',
  'orders:read': 'DEV_CLIENTS.SCOPES.ORDERS_READ',
  'orders:write': 'DEV_CLIENTS.SCOPES.ORDERS_WRITE',
  'store:read': 'DEV_CLIENTS.SCOPES.STORE_READ',
  'store:write': 'DEV_CLIENTS.SCOPES.STORE_WRITE',
  'users:read': 'DEV_CLIENTS.SCOPES.USERS_READ',
  'inventory:read': 'DEV_CLIENTS.SCOPES.INVENTORY_READ',
  'inventory:write': 'DEV_CLIENTS.SCOPES.INVENTORY_WRITE',
  'analytics:read': 'DEV_CLIENTS.SCOPES.ANALYTICS_READ',
  'receipts:read': 'DEV_CLIENTS.SCOPES.RECEIPTS_READ',
  'customers:pii': 'DEV_CLIENTS.SCOPES.CUSTOMERS_PII',
};

export const FONIX_SENSE_PRESET_SCOPES = ['receipts:read', 'customers:pii', 'products:read'];

export function scopeLabelKey(scope: string): string {
  return OAUTH_SCOPE_I18N_KEYS[scope] || scope;
}
